import { render, staticRenderFns } from "./OrgModifierGroup.vue?vue&type=template&id=062b0dc4&scoped=true&"
import script from "./OrgModifierGroup.vue?vue&type=script&lang=ts&"
export * from "./OrgModifierGroup.vue?vue&type=script&lang=ts&"
import style0 from "./OrgModifierGroup.vue?vue&type=style&index=0&id=062b0dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062b0dc4",
  null
  
)

export default component.exports